import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class GlobalTranslationApiService {
  private _apiBaseURL = `/api/pu/global-translations`;

  constructor(private http: HttpClient) { }

  getTranslaletionsByTypeAndId(entityType : any,entityId : any): Promise<any> {
    return this.http.get(`${this._apiBaseURL}/?entityType=${entityType}&entityId=${entityId}`).toPromise();
  }

  updateTranslaletionsByTypeAndId(entityType : any,entityId : any,translations : any): Promise<any> {
    return this.http.put(`${this._apiBaseURL}/`,{ entityType,entityId,translations }).toPromise();
  }

  getSingleTranslation(lang:string,text:string): Promise<any> {
    return this.http.put(`${this._apiBaseURL}/single-trans`, { lang, text } ).toPromise();
  }

  
}
